<template>
  <div id="app">
    <top-menu v-show="$route.path !='/login' ? true : false && $route.path !='/home' ? true : false"></top-menu>
    <router-view />
    <notifications group="foo" position="top right" animation-type="velocity"/>
  </div>
</template>

<script>
import TopMenu from './components/views/topheader'
import {mapState} from 'vuex'

    export default {
        components: {
            TopMenu
        },
        computed: {
            ...mapState({
                userStore: state => state.userStore
            })
        },
        created () {
            const userObj = JSON.parse(window.sessionStorage.getItem('authUser'))
            this.$store.dispatch('setUserObject', userObj)
        },
        name: 'App',
        data: function() {
            return{
                
            }
        },

        mounted() {
            console.log("%cStop", "background: red; color: yellow; font-size: 50px");
            console.log("%cThis is a browser feature intended for developers. If someone told you to copy-paste something here to enable a Some feature or hack someone's account, it is a scam and will give them access to your account.","color: gray; font-size: 20px")
        }
    }
</script>

<style lang="scss">
    @import "~styles/style.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue